module.exports = __webpack_public_path__ + "img/06-27-157.d1dd14db.jpg";